import { COLUMNSHEADING } from '../constants';
import getAllColumns from './getAllColumns';

export const getTopPODTitles = (sorting, TAB_ID) => {
  const allColumns = getAllColumns(sorting);

  const head = COLUMNSHEADING[TAB_ID].map(title => {
    switch (title) {
    case 'Title':
      return {
        title: 'Title',
        dataIndex: 'Title',
        key: 'Title',
        className: 'show',
        width: 220,
        render: (Title: string) => ({
          children: <span>{Title || ''}</span>
        })
      };

    case 'Print Price':
      return {
        title: () => sorting('Print Price'),
        dataIndex: 'Print Price',
        key: 'Print Price',
        className: 'show',
        width: 100,
        render(text) {
          let styles = {};
          const result = <span>${text || 0}</span>;

          if (Number(text) === 0 || !text) {
            styles = {
              background: 'rgb(255 157 157 / 36%)'
            };
          }

          return {
            props: {
              style: styles
            },
            children: result
          };
        }
      };

    case 'Total Units Sold':
      return {
        title: () => sorting('Total Units Sold'),
        dataIndex: 'Total Units Sold',
        key: 'Total Units Sold',
        className: 'show',
        width: 200
      };

    case 'Publisher Label':
      return {
        title: 'Publisher Label',
        dataIndex: 'Publisher Label',
        key: 'Publisher Label',
        className: 'show',
        width: 230
      };

    case 'Series Order':
      return {
        title: () => sorting('Series Order'),
        dataIndex: 'Series Order',
        key: 'Series Order',
        className: 'show',
        width: 150
      };

    default:
      return allColumns[title];
    }
  });

  return head;
};
